<template>
  <hypto-popup title="Your account is pending activation!" css="width-lg">
    <template v-slot:body>
      <p>Your account is pending activation.</p>
      <p>Please submit your documents to <a href="mailto:verify@hypto.in">verify@hypto.in</a> for activating your Hypto account. You can also chat with our support team and share your documents.</p>
      <documents />
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import Documents from '@/components/BlockedUsers/Documents'

export default {
  name: 'PendingVerification',
  components: { HyptoPopup, Documents }
}
</script>

<style scoped lang="scss">
  @import '@/assets/themes/main.scss';

  .hypto-popup {
    p {
      font-size: 15px;
      margin-bottom: 10px;
    }
    a {
      color: $primary !important;
      text-decoration: underline;
    }
  }

  .tablet, .mobile {
    .hypto-popup {
      p {
        text-align: left;
      }
    }
  }
</style>
